import { render, staticRenderFns } from "./PDPCommentReview.vue?vue&type=template&id=629911ba&scoped=true&"
import script from "./PDPCommentReview.vue?vue&type=script&lang=js&"
export * from "./PDPCommentReview.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentReview.vue?vue&type=style&index=0&id=629911ba&prod&lang=css&"
import style1 from "./PDPCommentReview.vue?vue&type=style&index=1&id=629911ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629911ba",
  null
  
)

export default component.exports